var _SocialLink, _SocialLink2, _SocialLink3, _SocialLink4, _SocialLink5, _CurrencyLoader;
import Facebook from "@crehana/compass.icons.fill/Facebook";
import Linkedin from "@crehana/compass.icons.fill/Linkedin";
import Twitter from "@crehana/compass.icons.fill/Twitter";
import Instagram from "@crehana/icons/Instagram";
import Youtube from "@crehana/icons/Youtube";
// biome-ignore lint/style/noRestrictedImports: legacy import, will be migrated
import { Col, Row } from "@crehana/ui";
import { clsx } from "clsx";
import LazyLoad from "../../../Lazyload";
import Loadable from "../../../Loadable";
import AppsColumn from "../../components/AppsColumn";
import CurrencyLoader from "../../components/CurrencyLoader";
import Copyright from "./Copyright";
import SocialLink from "./SocialLink";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var BottomSection = function BottomSection(_ref) {
  var isDark = _ref.isDark,
    _ref$shouldHideCurren = _ref.shouldHideCurrencySelector,
    shouldHideCurrencySelector = _ref$shouldHideCurren === void 0 ? false : _ref$shouldHideCurren,
    _ref$shouldHideAppsCo = _ref.shouldHideAppsColumn,
    shouldHideAppsColumn = _ref$shouldHideAppsCo === void 0 ? false : _ref$shouldHideAppsCo;
  return /*#__PURE__*/_jsxs(Row, {
    className: "tw-flex tw-items-center tw-pb-3.2 sm:tw-pb-4.8 lg:tw-pb-6.4 md:tw-items-end lg:tw-items-center",
    children: [/*#__PURE__*/_jsx(Copyright, {
      isDark: isDark,
      className: "tw-hidden md:tw-block"
    }), !shouldHideAppsColumn && /*#__PURE__*/_jsx(AppsColumn, {
      isDark: isDark,
      className: "tw-flex tw-flex-col tw-items-center tw-mb-2.4 md:tw-hidden sm:tw-mb-0 sm:tw-items-start"
    }), /*#__PURE__*/_jsxs(Col, {
      sm: 5,
      md: 4,
      lg: 6,
      offset: {
        sm: 1,
        md: 0
      },
      nowrap: true,
      className: "tw-flex tw-flex-col tw-items-center tw-self-end tw-justify-end sm:tw-items-start md:tw-items-end lg:tw-items-center lg:tw-flex-row",
      children: [/*#__PURE__*/_jsxs("span", {
        className: clsx('md:tw-mr-1.2 tw-flex tw-text-neutral-light-700 dark:tw-text-neutral-dark-100', !shouldHideCurrencySelector && 'tw-mb-2.4 sm:tw-mb-3.2 md:tw-mb-2.4 lg:tw-mb-0'),
        children: [_SocialLink || (_SocialLink = /*#__PURE__*/_jsx(SocialLink, {
          link: "https://www.facebook.com/Crehanacom/",
          icon: Facebook
        })), _SocialLink2 || (_SocialLink2 = /*#__PURE__*/_jsx(SocialLink, {
          link: "https://twitter.com/crehanacom",
          icon: Twitter
        })), _SocialLink3 || (_SocialLink3 = /*#__PURE__*/_jsx(SocialLink, {
          link: "https://www.instagram.com/crehanacom/",
          icon: Instagram
        })), _SocialLink4 || (_SocialLink4 = /*#__PURE__*/_jsx(SocialLink, {
          link: "https://www.linkedin.com/school/crehana/",
          icon: Linkedin
        })), _SocialLink5 || (_SocialLink5 = /*#__PURE__*/_jsx(SocialLink, {
          link: "https://www.youtube.com/channel/UCg6_yPdtalblZ0Peqjv5rPg/featured",
          icon: Youtube
        }))]
      }), !shouldHideCurrencySelector && /*#__PURE__*/_jsx(LazyLoad, {
        children: /*#__PURE__*/_jsx(Loadable, {
          module: function module() {
            return import(/* webpackChunkName: "main-footer-currency-dropdown"  */"../../components/CurrencyDropdownSelector");
          },
          Loader: _CurrencyLoader || (_CurrencyLoader = /*#__PURE__*/_jsx(CurrencyLoader, {})),
          isDark: isDark
        })
      })]
    }), /*#__PURE__*/_jsx(Copyright, {
      isDark: isDark,
      className: "md:tw-hidden"
    })]
  });
};
export default BottomSection;